
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR';
export const USER_LOGOUT_ERROR = 'USER_LOGOUT_ERROR';


function loggingIn(username){

    console.log(" LOGGIN IN");
    return {
        type: 'USER_LOGGING_IN',
        username: null,
        frontend: 'loading'

    }
}

function logInSuccess(username){
    console.log(" LOG IN SUCCESS");
    return {
        type: 'USER_LOGIN',
        username: username,
        authenticated: true,
        frontend: 'success'
    }
}

function logInError(username){
    console.log(" LOG IN ERROR");
    return {
        type: 'USER_LOGIN_ERROR',
        username: null,
        frontend: 'error'
    }
}

export function logIn(username,password){

    return function (dispatch){

        // Set The State To Loggin In
        dispatch(loggingIn(username));

        // Set Ajax Request
        let success = true;
        if(success){
            dispatch(logInSuccess(username))
        } else {
            dispatch(logInError(username));
        }

    }
}

// LOG OUT
function loggingOut(username){

    console.log(" LOGGIN OUT");
    return {
        type: 'USER_LOGGING_OUT',
        username: null
    }
}

function logOutSuccess(username){
    console.log(" LOG OUT SUCCESS");
    return {
        type: 'USER_LOGOUT',
        username: username,
        authenticated: false,
    }
}

function logOutError(username){
    console.log(" LOG OUT ERROR");
    return {
        type: 'USER_LOGOUT_ERROR',
        username: null
    }
}

export function logOut(username){

    return function (dispatch){

        // Set The State To Loggin In
        dispatch(loggingOut(username));

        // Set Ajax Request
        let success = true;
        if(success){
            dispatch(logOutSuccess(username))
        } else {
            dispatch(logOutError(username));
        }

    }
}





//https://redux.js.org/advanced/async-actions



// WEBPACK FOOTER //
// ./src/Actions/Login.js